import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-list-check",
  "use": "foquz-icon-list-check-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol viewBox=\"0 0 18 16\" fill=\"none\" id=\"foquz-icon-list-check\"><path d=\"M9.334 2h7.503M9.334 8h7.503m-7.503 6h7.503m-15.504-.485L2.994 15l3.34-3\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M3.333 4a2 2 0 100-4 2 2 0 000 4zm0 6a2 2 0 100-4 2 2 0 000 4z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol